import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TrainingEvents = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 6H17V5C17 4.45 16.55 4 16 4C15.45 4 15 4.45 15 5V6H7C5.35 6 4 7.35 4 9V19C4 20.65 5.35 22 7 22H11.137L8.174 26.45C8.074 26.613 8.012 26.8 8.012 27C8.012 27.55 8.462 28 9.012 28C9.362 28 9.662 27.825 9.85 27.55L13.55 22H15V25C15 25.55 15.45 26 16 26C16.55 26 17 25.55 17 25V22H18.462L22.162 27.55C22.337 27.812 22.65 28 22.999 28C23.549 28 23.999 27.55 23.999 27C23.999 26.8 23.936 26.6 23.836 26.45L20.874 22H24.999C26.649 22 27.999 20.65 27.999 19V9C27.999 7.35 26.649 6 24.999 6H25ZM26 19C26 19.55 25.55 20 25 20H7C6.45 20 6 19.55 6 19V9C6 8.45 6.45 8 7 8H25C25.55 8 26 8.45 26 9V19Z" />
	</svg>
);

export default TrainingEvents;
